import Dialog, {DialogCloseEventArgs} from "../../1. Core/Controls/Dialog/Dialog";

import ListBox from "../../1. Core/Controls/ListBox/ListBox";
import {PageMode} from "../../10. Battle/types";
import {IUserInfo} from "../../1. Core/UserInfo";
import {ServerAPI} from "../../1. Core/ServerAPI";

export default class UserFeatureDialog extends Dialog {

	private _list: ListBox;
	private _User: IUserInfo;


	_initFields(settings: object)
	{

		this._User = null;
		super._initFields(settings);
		this._Caption = this._User.Email;
		this._ShowHeader = true;
		this.EvOkButtonClick.add(this.saveClick, this);
	}

	_render()
	{
		super._render();

		this._list = new ListBox({
			ParentNode: this._contentNode,
			Items: [
				{Value: PageMode.mmaathletes, Content: 'MMA Athletes', IsCheckBox: true},
				{Value: PageMode.mmaresults, Content: 'MMA Battles', IsCheckBox: true},
				{Value: PageMode.mmarefereeing, Content: 'MMA Refereeing', IsCheckBox: true},
				{Value: PageMode.mmaevents, Content: 'MMA Events', IsCheckBox: true},
				{Value: PageMode.mmarating, Content: 'MMA Rating', IsCheckBox: true},
				{Value: PageMode.mmahighlights, Content: 'MMA Highlights', IsCheckBox: true},

				{IsSeparator: true},

				{Value: PageMode.kickboxers, Content: 'Kickboxing Athletes', IsCheckBox: true},
				{Value: PageMode.kbbouts, Content: 'Kickboxing Battles', IsCheckBox: true},
				{Value: PageMode.kbevents, Content: 'Kickboxing Events', IsCheckBox: true},

				{IsSeparator: true},

				{Value: PageMode.boxers, Content: 'Boxing Athletes', IsCheckBox: true},
				{Value: PageMode.boxresults, Content: 'Boxing Battles', IsCheckBox: true},
				{Value: PageMode.boxrefereeing, Content: 'Boxing Refereeing', IsCheckBox: true},

				{IsSeparator: true},

				{Value: PageMode.bookmaker, Content: 'Bookmaker', IsCheckBox: true},
				{Value: PageMode.fantasy, Content: 'Fantasy', IsCheckBox: true},
				{Value: PageMode.widgets, Content: 'Widgets', IsCheckBox: true}
			]
		});

		if (this._User.Features)
			this._User.Features.forEach(f => {
				let itm = this._list.getItem(f);
				if (itm)
					itm.setSelected(true)
			})
	}

	async saveClick(sender: object, args: DialogCloseEventArgs)
	{
		args.IsCancelClose = true;
		this._User.Features = this._list.getSelectedItems().map(itm => itm.getValue());
		await ServerAPI.post(`/users/${this._User.Id}`, this._User)
		this.hide();
	}
}